import { useQuery } from '@tanstack/react-query';
import { riskDashboardApi, type RiskSummaryResponse } from '../api/services/risk-dashboard';

export function useRiskDashboard() {
  return useQuery<RiskSummaryResponse>({
    queryKey: ['admin', 'risk', 'summary'],
    queryFn: () => riskDashboardApi.getSummary(),
  });
}
